// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2oHm_jRDqq7U8vkp2_SSZw","row":"_3BduAC-x2jmzQG2EkusVgO","col":"xGLMlk1rGzq0mJy8MxfyJ","hr":"_2PTmijY1_ItQoDzOWwSX2v"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Divider/styles.scss
 ** module id = 479
 ** module chunks = 0
 **/